import { Button, Heading, Text } from '@chakra-ui/react';
import { Link, Route, Routes } from 'react-router-dom';
import { AuthCreate } from '../pages/auth/AuthCreate';
import { AuthLogin } from '../pages/auth/AuthLogin';
import { Bar } from '../components/Bar';
import { AuthLayout } from './AuthLayout';
import { FormLayout } from './FormLayout';

export const Auth = () => {
    return (
        <>
            <Bar>
                <br />
                <Heading size="md">Welcome!</Heading>
                <br />
            </Bar>
            <AuthLayout>
                <Routes>
                    <Route path="/" element={(
                        <FormLayout>
                            <Button as={Link} to="/auth/create" colorScheme="blue" w="100%">Create new account</Button>
                            <Text my={4}>or</Text>
                            <Button as={Link} to="/auth/login" colorScheme="blue" w="100%">Login</Button>
                        </FormLayout>
                    )} />
                    <Route path="/create" element={<AuthCreate />} />
                    <Route path="/login" element={<AuthLogin />} />
                </Routes>
            </AuthLayout>
        </>
    )
}